import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import type { FlagProps } from '../types';
import classes from '../flagpack.module.css';

export function ECFlag({ radius, className, size, ...others }: FlagProps) {
  return (
    <Box
      className={cx(classes.flag, className)}
      __vars={{ '--flag-radius': getRadius(radius), '--flag-size': rem(size) }}
      {...others}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24">
        <defs>
          <mask id="mantine-ajgnr2cfq" fill="#fff">
            <path fillRule="evenodd" d="M0 0h32v24H0z" />
          </mask>
          <mask id="mantine-xbqkcryop" fill="#fff">
            <use fillRule="evenodd" xlinkHref="#mantine-yudt0cg8t" />
          </mask>
          <mask id="mantine-nq3823rpi" fill="#fff">
            <path
              fillRule="evenodd"
              d="M3.414 9.662c1.565 0 2.834-2.015 2.834-4.5 0-2.486-1.269-4.5-2.834-4.5S.581 2.676.581 5.162c0 2.485 1.269 4.5 2.833 4.5z"
            />
          </mask>
          <path id="mantine-yudt0cg8t" d="M0 0h32v24H0z" />
        </defs>
        <g fill="none" fillRule="evenodd" mask="url(#mantine-ajgnr2cfq)">
          <use fill="#2e42a5" xlinkHref="#mantine-yudt0cg8t" />
          <path fill="#feca00" d="M0 0h32v12H0z" mask="url(#mantine-xbqkcryop)" />
          <path fill="#e31d1c" d="M0 18h32v6H0z" mask="url(#mantine-xbqkcryop)" />
          <g mask="url(#mantine-xbqkcryop)">
            <path
              fill="#7b2900"
              d="M9.717 5.714C12.487 4.462 14 3.908 14.251 4.05c.378.213.469.821.795.821.326 0 .983-.192 1.257-.192.183 0 .364.064.545.192h1.17v-.65l5.309 1.493c-2.064.27-3.174.405-3.33.405-.155 0-.155.11 0 .333-.294-.222-.665-.333-1.113-.333s-1.127.231-2.036.694l.496 1.066-.496.314-.545-.314c.023-.584-.043-.876-.2-.876-.234 0-.405.563-.405.876 0 .21-.218.314-.652.314l.291-.587c.193-.649.096-.973-.29-.973s-1.463-.171-3.226-.514l-.676.333.242-.738z"
            />
            <path
              fill="#e31d1c"
              d="M15.921 18.055c.031 2.126-.04 3.28-.211 3.462-.257.272-.57 0-.977 0-.27 0 0-.903.813-2.71zm-4.42-6.969l1.26.662c-.149.753-.172 2.178.3 3.343.314.776 1.066 1.47 2.255 2.082.6.134.444.249-.468.345-1.366.145-2.698-.286-3.347-1.744-.432-.972-.432-2.534 0-4.688z"
            />
            <path
              fill="#2e42a5"
              d="M15.674 18.559c-.477 2.054-.883 3.08-1.216 3.08-.3 0-.24-.152-.144-.33l.066-.123a.56.56 0 00.078-.236c0-.177-.168-.088-.502.267l.502-1.792.707-.866zm-5.043-8.394l.853.61c-.125 1.125-.125 4.036.597 5.297.481.841 1.777 1.438 3.887 1.791-.416.308-1.006.534-1.77.678-1.145.216-3.328-1.066-3.871-3.243-.363-1.451-.261-3.162.304-5.133z"
            />
            <path
              fill="#feca00"
              d="M15.061 18.719c-.265.656-.561.984-.889.984-.49 0 0-.287-.486-.287-.323 0-.253-.233.212-.697zm-5.293-9.4l.853.61c-.386 1.085-.266 4.197 0 5.742.177 1.03 1.106 1.856 2.785 2.476-.416.308-1.006.534-1.77.678-1.144.216-1.868-1.28-2.138-3.154-.18-1.25-.09-3.366.27-6.351z"
            />
            <path
              fill="#e31d1c"
              d="M15.945 18.055c-.03 2.126.04 3.28.212 3.462.257.272.57 0 .976 0 .271 0 0-.903-.812-2.71zm4.42-6.969l-1.26.662c.15.753.173 2.178-.299 3.343-.315.776-1.066 1.47-2.255 2.082-.6.134-.444.249.467.345 1.367.145 2.699-.286 3.347-1.744.433-.972.433-2.534 0-4.688z"
            />
            <path
              fill="#2e42a5"
              d="M16.192 18.559c.478 2.054.883 3.08 1.217 3.08.3 0 .24-.152.144-.33l-.066-.123a.56.56 0 01-.078-.236c0-.177.167-.088.502.267l-.502-1.792-.708-.866zm5.043-8.394l-.853.61c.125 1.125.125 4.036-.596 5.297-.481.841-1.777 1.438-3.887 1.791.416.308 1.006.534 1.77.678 1.144.216 3.327-1.066 3.87-3.243.363-1.451.262-3.162-.304-5.133z"
            />
            <path
              fill="#feca00"
              d="M16.805 18.719c.266.656.562.984.89.984.49 0 0-.287.485-.287.324 0 .253-.233-.212-.697zm5.294-9.4l-.853.61c.385 1.085.266 4.197 0 5.742-.178 1.03-1.106 1.856-2.786 2.476.417.308 1.006.534 1.77.678 1.145.216 1.87-1.28 2.139-3.154.18-1.25.09-3.366-.27-6.351z"
            />
            <path
              fill="#6fae21"
              fillRule="nonzero"
              d="M10.203 10.446l.091-.552 1.601.103-1.214-1.258.41-.389 1.641 1.701-1.404-2.64.486-.288 1.278 1.88-.61-1.954.525-.209 1.965 3.92-.754-.049.074.237.642.17-.146.544-.298-.08.278.892-.483-.71.841 1.58-2.066-2.14zm11.723 0l-.091-.552-1.601.103 1.214-1.258-.41-.389-1.641 1.701 1.404-2.64-.486-.288-1.278 1.88.61-1.954-.525-.209-1.965 3.92.754-.049-.074.237-.642.17.146.544.298-.08-.278.892.483-.71-.841 1.58 2.066-2.14z"
            />
            <path
              fill="#171401"
              fillRule="nonzero"
              d="M11.067 21.311l-.413-.386 12.19-12.834.413.385z"
            />
            <path
              fill="#cececc"
              d="M22.535 8.19l.625.589.352-.975zM11.376 21.309l-.718-.472-.232.967z"
            />
            <path
              fill="#171401"
              fillRule="nonzero"
              d="M10.16 19.399l-.412-.386 12.19-12.835.412.386z"
            />
            <path
              fill="#cececc"
              d="M21.628 6.277l.626.59.352-.975zM10.47 19.396l-.718-.472-.233.968z"
            />
            <path
              fill="#171401"
              fillRule="nonzero"
              d="M21.253 21.311l.413-.386L9.476 8.091l-.413.385z"
            />
            <path
              fill="#cececc"
              d="M9.785 8.19l-.625.589-.352-.975zm11.159 13.119l.718-.472.232.967z"
            />
            <path
              fill="#171401"
              fillRule="nonzero"
              d="M22.387 19.849l.412-.386-12.19-12.835-.413.386z"
            />
            <path
              fill="#cececc"
              d="M10.918 6.727l-.625.59-.352-.975zm11.159 13.119l.718-.472.232.968z"
            />
            <path fill="#b74e01" d="M13.667 16.375H18.2v2.25h-4.533z" />
            <path
              stroke="#feca00"
              strokeWidth=".5"
              d="M15.948 7.787c.858 0 1.648.534 2.215 1.435.534.848.868 2.02.868 3.315s-.334 2.467-.868 3.315c-.567.9-1.357 1.435-2.215 1.435s-1.648-.535-2.215-1.435c-.534-.848-.869-2.02-.869-3.315 0-1.296.335-2.467.869-3.315.567-.9 1.357-1.435 2.215-1.435z"
            />
            <path
              fill="#6fae21"
              d="M.346 5.235h1.612c.74.164.924.31.555.439-.555.193-.555.257-.555.532v1.5c0 .215.395.676-.436.676-.554 0-1.07-1.139-1.547-3.416z"
              mask="url(#mantine-nq3823rpi)"
              transform="translate(12.533 7.375)"
            />
            <path
              fill="#6fae21"
              d="M6.646 5.42c-.999.198-1.84.263-2.524.198-.684-.066-1.176-.132-1.476-.198.476.248.8.476.969.684.254.312.775.85 1.305.85s1.344.504 1.344.504l.382-2.038z"
              mask="url(#mantine-nq3823rpi)"
              transform="translate(12.533 7.375)"
            />
            <path
              fill="#f7fcff"
              d="M.785 2.76c.824.16 1.334.358 1.532.596.298.358-.392.715 1.407.358s3.227-.98 3.227 0-.158 1.883-.932 1.883H2.575c-2.36 0-3.648.723-3.482-.44.11-.774.674-1.573 1.692-2.396z"
              mask="url(#mantine-nq3823rpi)"
              transform="translate(12.533 7.375)"
            />
          </g>
        </g>
      </svg>
    </Box>
  );
}
